import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction } from '../../serviceCall'

const sendReportOfDiagonsisApi = (data, callback, errorCallBack,params) => {
  
  return async (dispatch) => {
 
    formDataCommonFunction(data,apiConstants.REPORT.SEND_REPORT)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default sendReportOfDiagonsisApi;